export const getApiErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  const candidate = error as {
    message?: string;
    response?: {
      data?: {
        message?: string;
        detail?: string | { message?: string };
      };
    };
  };

  const detail = candidate?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }

  if (
    detail &&
    typeof detail === "object" &&
    typeof detail.message === "string" &&
    detail.message.trim()
  ) {
    return detail.message;
  }

  if (
    typeof candidate?.response?.data?.message === "string" &&
    candidate.response.data.message.trim()
  ) {
    return candidate.response.data.message;
  }

  if (typeof candidate?.message === "string" && candidate.message.trim()) {
    return candidate.message;
  }

  return fallback;
};
